import React, { Component } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import FormLabel from "@mui/material/FormLabel";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import LoadingCircular from "../LoadingCircular";

class EstekhdamForm extends Component {
  state = {
    step: 1,
    isLoading: false,
    name: "",
    family: "",
    dadName: "",
    mahaleSodor: "",
    birthday: "",
    codeMeli: "",
    certificate: "",
    certificateField: "",
    computerSkills: "",
    englishSkills: "",
    relationship: "",
    nezamVazife: "",
    address: "",
    telephone: "",
    mobile: "",
    email: "",
    savabegh: "",
    nemuneKar: "",
    minHoghogh: "",
  };
  onSubmit = async (e) => {
    e.preventDefault();
    if (
      this.state.name === "" ||
      this.state.family === "" ||
      this.state.dadName === "" ||
      this.state.mahaleSodor === "" ||
      this.state.birthday === "" ||
      this.state.codeMeli === "" ||
      this.state.certificateField === "" ||
      this.state.computerSkills === "" ||
      this.state.englishSkills === "" ||
      this.state.relationship === "" ||
      this.state.nezamVazife === "" ||
      this.state.address === "" ||
      this.state.mobile === "" ||
      this.state.email === "" ||
      this.state.savabegh === "" ||
      this.state.nemuneKar === "" ||
      this.state.minHoghogh === ""
    ) {
      alert("لطفا موارد ستاره دار را تکمیل نمایید");
      return;
    }
    //send to api
    const estekhdamForm = {
      UserMobile: this.props.mobileNumber,
      Name: this.state.name,
      Family: this.state.family,
      DadName: this.state.dadName,
      MahaleSodor: this.state.mahaleSodor,
      Birthday: this.state.birthday,
      CodeMeli: this.state.codeMeli,
      Certificate: this.state.certificate,
      CertificateField: this.state.certificateField,
      ComputerSkills: this.state.computerSkills,
      EnglishSkills: this.state.englishSkills,
      Relationship: this.state.relationship,
      NezamVazife: this.state.nezamVazife,
      Address: this.state.address,
      Telephone: this.state.telephone === "" ? null : this.state.telephone,
      Mobile: this.state.mobile,
      Email: this.state.email,
      Savabegh: this.state.savabegh,
      NemuneKar: this.state.nemuneKar,
      MinHoghogh: this.state.minHoghogh,
    };
    this.setState({ isLoading: true });
    const res = await fetch("/ng/api/JobRequest", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(estekhdamForm),
    });
    const dataBack = await res.json();
    this.setState({ isLoading: false });
    if (dataBack.Result === "Ok") {
      this.setState({ step: 2 });
    } else {
      alert("پاسخی از سرور دریافت نشد");
    }
  };
  render() {
    const { step, isLoading } = this.state;
    switch (step) {
      case 1:
        return (
          <Stack
            component="form"
            spacing={1.5}
            noValidate
            autoComplete="off"
            onSubmit={this.onSubmit}
          >
            <LoadingCircular open={isLoading} />
            <Typography variant="h6" sx={{ textAlign: "center" }}>
              فرم همکاری با ما
            </Typography>
            <TextField
              required
              label="نام"
              variant="standard"
              onChange={(e) => {
                this.setState({ name: e.target.value });
              }}
            />
            <TextField
              required
              label="نام خانوادگی"
              variant="standard"
              onChange={(e) => {
                this.setState({ family: e.target.value });
              }}
            />
            <TextField
              required
              label="نام پدر"
              variant="standard"
              onChange={(e) => {
                this.setState({ dadName: e.target.value });
              }}
            />
            <TextField
              required
              label="محل صدور شناسنامه"
              variant="standard"
              onChange={(e) => {
                this.setState({ mahaleSodor: e.target.value });
              }}
            />
            <TextField
              required
              label="تاریخ تولد"
              variant="standard"
              onChange={(e) => {
                this.setState({ birthday: e.target.value });
              }}
            />
            <TextField
              required
              label="کد ملی"
              variant="standard"
              onChange={(e) => {
                this.setState({ codeMeli: e.target.value });
              }}
            />
            <FormControl fullWidth sx={{ paddingTop: 3 }}>
              <InputLabel sx={{ paddingTop: 3 }} id="lbl1">
                آخرین مدرک تحصیلی *
              </InputLabel>
              <Select
                required
                //sx={{ mt: 4 }}
                labelId="lbl1"
                value={this.state.certificate}
                id="demo-simple-select"
                label="آخرین مدرک تحصیلی *"
                onChange={(e) => {
                  this.setState({ certificate: e.target.value });
                }}
              >
                <MenuItem value="دیپلم">دیپلم</MenuItem>
                <MenuItem value="کاردانی">کاردانی</MenuItem>
                <MenuItem value="کارشناسی">کارشناسی</MenuItem>
                <MenuItem value="کارشناسی ارشد">کارشناسی ارشد</MenuItem>
                <MenuItem value="دکترا">دکترا</MenuItem>
              </Select>
            </FormControl>
            <TextField
              required
              label="رشته تحصیلی"
              variant="standard"
              onChange={(e) => {
                this.setState({ certificateField: e.target.value });
              }}
            />
            <FormControl required>
              <FormLabel id="compSkills">مهارت کار با کامپیوتر</FormLabel>
              <RadioGroup
                row
                aria-labelledby="compSkills"
                onChange={(e) => {
                  this.setState({ computerSkills: e.target.value });
                }}
                name="radio-buttons-group"
              >
                <FormControlLabel value="خوب" control={<Radio />} label="خوب" />
                <FormControlLabel
                  value="متوسط"
                  control={<Radio />}
                  label="متوسط"
                />
                <FormControlLabel
                  value="ضعیف"
                  control={<Radio />}
                  label="ضعیف"
                />
              </RadioGroup>
            </FormControl>
            <FormControl required>
              <FormLabel id="engSkills">زبان انگلیسی </FormLabel>
              <RadioGroup
                row
                aria-labelledby="engSkills"
                name="radio-buttons-group"
                onChange={(e) => {
                  this.setState({ englishSkills: e.target.value });
                }}
              >
                <FormControlLabel value="خوب" control={<Radio />} label="خوب" />
                <FormControlLabel
                  value="متوسط"
                  control={<Radio />}
                  label="متوسط"
                />
                <FormControlLabel
                  value="ضعیف"
                  control={<Radio />}
                  label="ضعیف"
                />
              </RadioGroup>
            </FormControl>
            <FormControl required>
              <FormLabel id="relStatus">وضعیت تاهل</FormLabel>
              <RadioGroup
                row
                aria-labelledby="relStatus"
                name="radio-buttons-group"
                onChange={(e) => {
                  this.setState({ relationship: e.target.value });
                }}
              >
                <FormControlLabel
                  value="مجرد"
                  control={<Radio />}
                  label="مجرد"
                />
                <FormControlLabel
                  value="متاهل"
                  control={<Radio />}
                  label="متاهل"
                />
              </RadioGroup>
            </FormControl>
            <FormControl required fullWidth sx={{ paddingTop: 3 }}>
              <InputLabel sx={{ paddingTop: 3 }} id="lbl1">
                وضعیت نظام وظیفه
              </InputLabel>
              <Select
                required
                labelId="lbl1"
                value={this.state.nezamVazife}
                id="demo-simple-select"
                label="وضعیت نظام وظیفه"
                onChange={(e) => {
                  this.setState({ nezamVazife: e.target.value });
                }}
              >
                <MenuItem value="پایان خدمت">پایان خدمت</MenuItem>
                <MenuItem value="معافیت پزشکی">معافیت پزشکی</MenuItem>
                <MenuItem value="معافیت کفالت">معافیت کفالت</MenuItem>
                <MenuItem value="معافیت دائم">معافیت دائم</MenuItem>
                <MenuItem value="سایر معافیت ها">سایر معافیت ها</MenuItem>
              </Select>
            </FormControl>
            <TextField
              required
              label="آدرس محل سکونت"
              variant="standard"
              multiline
              onChange={(e) => {
                this.setState({ address: e.target.value });
              }}
            />

            <TextField
              label="تلفن ثابت"
              variant="standard"
              type="tel"
              onChange={(e) => {
                this.setState({ telephone: e.target.value });
              }}
            />
            <TextField
              required
              label="تلفن همراه"
              variant="standard"
              type="tel"
              onChange={(e) => {
                this.setState({ mobile: e.target.value });
              }}
            />
            <TextField
              required
              label="ایمیل"
              variant="standard"
              type="email"
              onChange={(e) => {
                this.setState({ email: e.target.value });
              }}
            />
            <TextField
              required
              label="سوابق کاری"
              variant="standard"
              multiline
              onChange={(e) => {
                this.setState({ savabegh: e.target.value });
              }}
            />
            <TextField
              required
              label="زمینه های تخصص و نمونه کارها"
              variant="standard"
              multiline
              onChange={(e) => {
                this.setState({ nemuneKar: e.target.value });
              }}
            />
            <TextField
              required
              label="حداقل حقوق درخواستی"
              variant="standard"
              onChange={(e) => {
                this.setState({ minHoghogh: e.target.value });
              }}
            />
            <Button type="submit" variant="contained">
              ثبت
            </Button>
          </Stack>
        );
      case 2:
        return (
          <Typography sx={{ textAlign: "center" }}>
            درخواست شما با موفقیت ارسال شد
          </Typography>
        );
      default:
    }
  }
}

export default EstekhdamForm;
